const FORM_STORAGE_KEY = "establishment_form_data";
const FORM_TIMESTAMP_KEY = "establishment_form_timestamp";

export const clearFormStorage = () => {
  try {
    sessionStorage.removeItem(FORM_STORAGE_KEY);
    sessionStorage.removeItem(FORM_TIMESTAMP_KEY);
  } catch (error) {
    console.warn("Erro ao limpar sessionStorage:", error);
  }
};
